<template>
    <div class="custom-cursor" v-bind:style="computedPosition">
        <div class="custom-cursor-object">click</div>
    </div>
</template>

<script>
export default {
    name: "custom_cursor",
    data: function() {
        return {
            mousePosition: {},
            doAnimate: false,
            cursorX: 0,
            cursorY: 0
        };
    },
    computed: {
        computedPosition: function() {
            return {
                transform:
                    "translate3d(" +
                    this.cursorX +
                    "px, " +
                    this.cursorY +
                    "px, 0)"
            };
        }
    },
    mounted: function() {
        document.addEventListener("mousemove", this.trackMousePosition);

        this.$store.subscribe((mutation, state) => {
            let cursorState = state.cursorChange;

            if (mutation.type == "cursorChange") {
                if (cursorState) {
                    this.cursorX = state.mouseEvent.pageX;
                    this.cursorY = state.mouseEvent.pageY;

                    requestAnimationFrame(this.followCursor);
                    this.$el.classList.add("show");
                    this.doAnimate = true;
                } else {
                    this.doAnimate = false;
                    cancelAnimationFrame(this.followCursor);
                    this.$el.classList.remove("show");
                }
            }
        });
    },
    methods: {
        followCursor: function() {
            let customCursor = this.$el;
            let dX = this.mousePosition.pageX - this.cursorX;
            let dY = this.mousePosition.pageY - this.cursorY;

            this.cursorX += dX / 8;
            this.cursorY += dY / 8;

            if (this.doAnimate) requestAnimationFrame(this.followCursor);
        },
        trackMousePosition: function(event) {
            this.mousePosition = event;
        }
    }
};
</script>

<style lang="scss">
.custom-cursor {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;

    &-object {
        @include mukta-medium;
        font-size: 14px;
        text-transform: lowercase;
        width: 60px;
        height: 60px;
        background-color: #ff5a3c;
        color: white;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: -30px;
        top: -30px;
        transition: transform 0.15s $primary-ease;
        transform: scale(0, 0);
    }

    &.show {
        .custom-cursor-object {
            transform: scale(1, 1);
        }
    }
}
</style>
